module.exports = __webpack_public_path__ + "img/tema-3-6.374d8a9c.png";